<template>
  <div>
    <GlobSpinner :isLoading="isLoading"></GlobSpinner>
  <button v-if="userCanHandleOrders()" @click="setArticleModal(true)" class="button">{{ $t('storage.articles.add_article') }}</button>
  <GlobTable
    :data="articles"
    :enableEditing="enableEditing"
    :fields="fields"
    @change-item="(item) => updateArticle(item)"
    :actions="actions"
  />
 </div>
  <GlobModal :show="articleModal" :width="500" :widthInPx="true" :title="$t('storage.articles.add_article')" @close="setArticleModal(false)">
    <InputText :fullWidth="true" :placeholder="$t('storage.articles.search_article')" v-model="articleSearchString" @input="searchArticle" />
    <GlobTable :data="searchResult" :actions="addActions" style="height: 30vh" />
  </GlobModal>

  <GlobModal :show="articleStatModal" :isLoaded="articleStatLoaded" :width="50" :title="$t('storage.articles.article_transactions')" @close="setArticleStatModal(false)">
    <ChartLine
      :name="$t('storage.articles.article_transactions')"
			:xPanel="false"
      :axisX="'date'"
      :axisY="'value'"
      :data="articleTransactionData"
    />
  </GlobModal>
  <GlobLoader v-if="!articleStatLoaded"/>

</template>

<script>
import { useRouter } from "vue-router";
import { reactive, onMounted, ref, shallowRef, computed } from "vue";
import { useApi } from "@/plugins/api";
import { useNotifications } from "@/plugins/notifications";
import { usePermissions } from "@/plugins/permissions";
import { useI18n  } from "vue-i18n";	
export default {
  props: {
	  userRole: {
		  type : String,
		  default: null
		},
		allowEnduserToSetPlacement: {
			type: Boolean,
			default: true
	  }
  },
  setup(props) {
    const router = useRouter();
    const api = useApi();
	const { tm } = useI18n();
    const isLoading = ref(false);
    const id = ref(router.currentRoute.value.params.id);
    const notifications = useNotifications();
		const { userCanHandleOrders } = usePermissions();

    const getData = async () => {
      isLoading.value = true;
      await api.lockers.getArticles(id.value).then((res) => {
        articles.body = res.data;
        isLoading.value = false;
      });
    };

    const updateArticle = (item) => {
      api.lockers.updateArticle(id.value, {
        data: [item]
      });
    };
    const deleteArticle = (item) => {
      api.lockers.deleteArticle(id.value, item.LockerArticleId).then((res) => {
        getData();
        notifications.push(
          {
            title: "Artikel borttagen",
            msg: `Tog bort <b>&#160;${item.name}</b>`
          },
          "success",
          false
        );
      });
    };

	const tableHead = computed(() => 
	    [
			{
				Alias: "ArticleNumber",
				Value: tm('storage')['articles']['article_number']
			},
			{
				Alias: "name",
				Value: tm('storage')['articles']['article_name']
			},
			{
				Alias: "CurrentVolume",
				Value: tm('storage')['articles']['current_volume']
			},
			{
				Alias: "PlaceOrderAmount",
				Value: tm('storage')['articles']['place_order_amount']
			},
			{
				Alias: "Shelf",
				Value: tm('storage')['articles']['shelf']
			},
			{
				Alias: "Placement",
				Value: tm('storage')['articles']['placement']
			},
			{
				Alias: "MaxStock",
				Value: tm('storage')['articles']['max_stock']
			},
			{
				Alias: "EndCustomerArticlePrice",
				Value: tm('storage')['articles']['end_customer_article_price']
			}
		]
	);

    const articles = reactive({
      body: [],
      head: tableHead.value
    });

	  const fields = computed(() => {
		if (props.userRole == 'reseller') {
			return [
					{ key: "CurrentVolume", type: "number" },
					{ key: "PlaceOrderAmount", type: "number" },
					{ key: "Shelf", type: "number" },
					{ key: "Placement", type: "text" },
					{ key: "MaxStock", type: "number" },
					{ key: "EndCustomerArticlePrice", type: "number"}
				]
		}else if (props.allowEnduserToSetPlacement) {
			return [
					{ key: "Placement", type: "number" },
				]
		}

		  return [];
	})

	  const enableEditing = computed(() => {
		  if (props.userRole == 'reseller' || props.allowEnduserToSetPlacement)
		  {
			  return true;
		  }

		  return false;
	  });

    const articleStatModal = ref(false);
    const articleStatLoaded = ref(true);
    const setArticleStatModal = (bool) => {
      articleStatModal.value = bool;
    };
    const articleTransactionData = ref([]);

    const actions = [
      ...(userCanHandleOrders() ? [{
        name: tm('general')['button']['delete'],
        color: "red",
        requirements: {
          consequence: (obj) => `Är du säker på att du vill radera ${obj.name} (${obj.ArticleNumber})?`
        },
        action: (obj) => {
          deleteArticle(obj);
        }
      }] : []),
      {
        name: tm('storage')['articles']['statstistics'],
        color: "green",
        action: (obj) => {
					articleStatLoaded.value = false;
          api.analytics.getArticleTransactions(id.value, obj.LockerArticleId).then((res) => {
            articleTransactionData.value = [{
              name: obj.name,
              data: res.data.map((i) => ({
                date: new Date(i.TransactionDate),
                value: i.TransactionAmount
              }))
            }];
            setArticleStatModal(true);
						console.log(articleTransactionData.value);
						return true;
          }).then(res => {
						articleStatLoaded.value = true;
					});
        }
      }
    ];

    const addActions = [
      {
		name: tm('general')['button']['add'],
        color: "green",
        action: (obj) => {
          addArticle(obj);
        }
      }
    ];

    const articleSearchString = ref("");
    const articleModal = ref(false);
    const searchResult = reactive({
      body: [],
      head: [
        { Alias: "ArticleNumber", Value: tm('storage')['articles']['article_number'] },
        { Alias: "Name", Value: tm('storage')['articles']['article_name'] }
      ]
    });
    const setArticleModal = (bool) => {
      articleModal.value = bool;
    };
    const searchArticle = () => {
      api.lockers.searchArticle(id.value, articleSearchString.value).then((res) => {
        searchResult.body = res.data;
      });
    };

    const addArticle = (article) => {
      api.lockers.addArticle(id.value, article.Id).then((res) => {
        getData();
        searchArticle();
        notifications.push(
          {
            title: tm('storage')['articles']['article_added'],
			msg: tm('storage.articles.added_article').replace('{name}', article.Name)
          },
          "success",
          false
        );
      });
    };

    const log = (val) => console.log(val);

    onMounted(() => {
      getData();
      searchArticle();
    });

    return {
      articles,
      updateArticle,
      fields,
      actions,
      articleModal,
      setArticleModal,
      articleSearchString,
      searchArticle,
      searchResult,
      addActions,
      articleStatModal,
      setArticleStatModal,
			articleTransactionData,
			articleStatLoaded,
      log,
      userCanHandleOrders,
		isLoading,
	  enableEditing
    };
  }
};
</script>
